module.exports = __webpack_public_path__ + "static/media/eversportsCorporateLogo.360142e3.svg";